import { StaticImage } from "gatsby-plugin-image"

import { Button, Heading } from "@trueskin-web/components"
import { Trans } from "@trueskin-web/translations"

const Intro = ({ onDismiss }) => (
  <div
    sx={{
      display: "grid",
      gridTemplateRows: ["1fr auto", "auto"],
      gridTemplateColumns: [null, "2fr 3fr"],
      gridGap: [4, 8],
      alignItems: [null, "center"],
      textAlign: "center",
      maxWidth: [null, 800],
      mx: "auto",
      height: ["calc(100dvh - var(--header-height))", "auto"],
    }}
  >
    <div
      sx={{
        mx: [-4, 0],
        position: "relative",
      }}
    >
      <div
        sx={{
          position: ["absolute", "initial"],
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        }}
      >
        <StaticImage
          src="../../../images/persons_face_skins.jpg"
          alt=""
          sx={{
            width: "100%",
            height: "100%",
          }}
        />
      </div>
    </div>

    <div>
      <Heading
        sx={{
          fontWeight: "bold",
        }}
      >
        <Trans i18nKey="Start.Photos.Intro.title" />
      </Heading>

      <div
        sx={{
          mt: 3,
        }}
      >
        <Trans i18nKey="Start.Photos.Intro.description" />
      </div>

      <Button
        isFullWidth
        sx={{
          mt: [6, 6],
          mb: [4, 0],
        }}
        onClick={onDismiss}
      >
        <Trans i18nKey="Start.Photos.Intro.cta" />
      </Button>
    </div>
  </div>
)

export default Intro
